import { render } from "./usrinquire_confirm.vue?vue&type=template&id=213a6160&scoped=true"
import script from "./usrinquire_confirm.vue?vue&type=script&lang=js"
export * from "./usrinquire_confirm.vue?vue&type=script&lang=js"

import "./usrinquire_confirm.vue?vue&type=style&index=0&id=213a6160&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/div2-univRenewal-trunk-production/smt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-213a6160"]])

export default __exports__